import React, { useEffect, useState } from 'react';
import NavBar from "../../Componants/NavBar";
import { useNavigate } from "react-router-dom";
import CardLage from "../../Componants/CardLage";
import TableParticular from "../../Componants/Particular/TableParticular";
import { Ajax } from "../../Service/ajax";
import { GridLoader } from "react-spinners";
import AlertSuccess from "../../Componants/AlertSuccess";
import Footer from "../../Componants/Footer";
import {convertDate} from "../../config/AppConfig";
import { useMediaQuery } from 'react-responsive';
import Swal from "sweetalert2";
import SubscriptionSection from "../../Componants/SubscriptionSection";
import {security} from "../../env/Environment";
import EvaluationSection from "../../Componants/EvaluationSection";
export default function ReportView(){
    const navigate = useNavigate();
    const session = sessionStorage.getItem("session");
    const [loading, setLoading] = useState(false);
    const application=JSON.parse(sessionStorage.getItem("application"));
    const fetchData = async () => {
        try {
            setLoading(true);
            // Vérification de la session
            const {data} = await Ajax.getRequest(`/api/v1/sub/reports/monthly`,{params:{company:application.organisationId, cdf:250.0, usd:200.0}});
            console.log("rapport: ",data);
        }catch (e){
            console.log(e.message);
        }finally {
            setLoading(false);
        }
    }
    return(
        <>
            {loading ? (
                <div className="loading-overlay">
                    <div className="loading-spinner">
                        <GridLoader
                            color="#debf66"
                            loading
                            size={15}
                        />
                    </div>
                </div>
            ) : (
                <div className="layout-wrapper layout-content-navbar layout-without-menu">
                    <div className="layout-container">
                        <div className="layout-page">
                            <nav className="navbar navbar-example navbar-expand-lg bg-light layout-navbar-fixed">
                                <div className="container-fluid">
                                    <a type={"button"} className="display-7 text-black fw-bolder" onClick={()=>navigate("/")}>
                                        <img src={require("../../assets/img/illustrations/Netikash subscribe-2.png")} alt="Netiaksh Logo" className="mb-3" style={{width:150}}/>
                                    </a>
                                </div>
                            </nav>
                            <div className="content-wrapper">
                                <div className="container-xxl flex-grow-1 container-p-y">
                                    <div className="col-md-12 d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                                        <div className="d-flex flex-column justify-content-center align-items-center w-100">
                                            <i className="bx bx-bar-chart-alt  mb-3" style={{ fontSize: "6rem", color: "#eccd7e" }}></i>
                                            <h2 className="text-center mb-3">
                                                Bienvenue dans l'espace des rapports
                                            </h2>
                                            <p className="text-center mb-4">
                                                Cet espace vous permet d'accéder à des rapports détaillés pour analyser vos activités, suivre vos performances et obtenir des informations essentielles pour prendre des décisions éclairées.
                                            </p>
                                            <p className="text-center mb-4 text-muted">
                                                Vous n'avez encore aucun rapport.
                                            </p>
                                            <div className="d-flex justify-content-center gap-3">
                                                {/*<button className="btn btn-netikash mt-4" onClick={() => fetchData()} aria-label="Retour">*/}
                                                {/*    <span className="tf-icons bx bx-arrow-back"></span>*/}
                                                {/*    Generer rapports*/}
                                                {/*</button>*/}
                                                <button className="btn btn-netikash mt-4" onClick={() => navigate(-1)} aria-label="Retour">
                                                    <span className="tf-icons bx bx-arrow-back"></span>
                                                    Retour
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="content-backdrop fade"></div>
                            </div>
                            <Footer/>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
